module.exports = __webpack_public_path__ + "static/img/clock.47b6475a.svg";